@if (articles$ | async; as articles) {
  <nt-general-card appearance="widget">
    <div
      class="nt-container"
      style="background: none; width: 100%"
      *transloco="let t"
      >
      @if (articles.length) {
        <div class="nt-container nt-container--articles">
          @for (article of articles; track useArticleId(i, article); let i = $index) {
            <article [ngClass]="i | articleClasses">
              <div class="nt-cover">
                <img
                  [src]="article | articlePicture : defaultCover"
                  [alt]="article | translate : title"
                  />
              </div>
              @if (i === 0) {
                <h1 class="nt-title">
                  <a [routerLink]="article.slug">{{
                    article | translate : 'title'
                  }}</a>
                </h1>
              }
              @if (i !== 0) {
                <h2 class="nt-title">
                  <a [routerLink]="article.slug">{{
                    article | translate : 'title'
                  }}</a>
                </h2>
              }
              <p class="nt-description">
                {{ article | translate : 'description' }}&nbsp;
                <a [routerLink]="article.slug">{{ t('articles.read_more') }}</a>
              </p>
            </article>
            @if (i === 2) {
              <div
          style="
            flex-basis: 100%;
            font-size: 12px;
            font-weight: bold;
            padding: 0 24px;
          "
                >
                {{ t('articles.you_might_be_interested') }}
              </div>
            }
          }
          <footer class="nt-footer">
            @if (totalArticles > articles.length + (paginator?.page ?? 0)) {
              <button
                type="button"
                mat-flat-button
                color="primary"
                class="nt-btn"
                (click)="loadMore()"
                >
                {{ t('articles.load_more') }}
              </button>
            }
          </footer>
        </div>
      }
      @if (!articles.length) {
        <div
          class="nt-container nt-container--articles nt-container--articles-empty"
          >
          <h1 class="nt-title">{{ t('articles.no_articles') }}</h1>
          <a mat-flat-button color="primary" class="nt-btn" routerLink="/">
            {{ t('articles.back_home') }}
          </a>
        </div>
      }
    </div>
  </nt-general-card>
}
